import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { Field } from "@atlaskit/form";
import Textfield from "@atlaskit/textfield";
import { N200 } from "@atlaskit/theme/colors";

import { useSiteActivationContext } from "../../hooks/site-activation-context";

import { Dropdown } from "./components/dropdown";

export const SitePicker = () => {
    const { sitesWithoutCurrentProduct } = useSiteActivationContext();

    const sitePicker =
        sitesWithoutCurrentProduct.length === 1 ? (
            <div css={fieldWrapperCss}>
                <Field
                    aria-required
                    isRequired
                    isDisabled
                    name="site-picker-field"
                    id="site-picker-field"
                    data-testId="site-picker-field"
                    label={label}
                    defaultValue={sitesWithoutCurrentProduct[0]?.url.replace(
                        "https://",
                        ""
                    )}
                >
                    {({ fieldProps }) => <Textfield {...fieldProps} />}
                </Field>
            </div>
        ) : (
            <div css={fieldWrapperCss}>
                <Dropdown />
            </div>
        );

    return <div data-testid="site-picker">{sitePicker}</div>;
};

// submitting for translation
//@ts-ignore
const newMessage = (
    <FormattedMessage
        id="siteActivation.siteNameSitePickerLabel"
        defaultMessage="Your site"
    />
);

const label = (
    <span
        css={css({
            color: N200,
            fontWeight: 500
        })}
    >
        <FormattedMessage
            id="WacSignupForm.siteNameN2ELabel"
            defaultMessage="Your site"
        />
    </span>
);

const fieldWrapperCss = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["label + div > div:first-of-type, div[data-disabled]"]: {
        borderRadius: "21px"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["input, label + div > div > div"]: {
        paddingInlineStart: "12px !important"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["input"]: {
        fontSize: "1rem"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["label span:nth-of-type(2)"]: {
        display: "none"
    }
});
